import { ChainId } from 'types/chains';
import { defineChain } from 'viem';
const createChain = (id, name, nativeSymbol, rpcUrl, explorerUrl, explorerApiUrl) => defineChain({
    id,
    name,
    nativeCurrency: {
        name: nativeSymbol,
        symbol: nativeSymbol,
        decimals: 18,
    },
    rpcUrls: {
        default: { http: [rpcUrl] },
    },
    blockExplorers: {
        default: {
            name: `${name} Explorer`,
            url: explorerUrl,
            apiUrl: explorerApiUrl,
        },
    },
});
export const merlin = createChain(ChainId.MerlinTestnet, 'Merlin', 'tBTC', 'https://testnet-rpc.merlinchain.io', 'https://testnet-scan.merlinchain.io', 'https://testnet-scan.merlinchain.io/api');
export const sepolia = createChain(ChainId.Sepolia, 'Sepolia', 'tETH', 'https://sepolia.gateway.tenderly.co', 'https://sepolia.etherscan.io', 'https://api-sepolia.etherscan.io/api');
export const ethereumHolesky = createChain(ChainId.EthereumHolesky, 'Ethereum Holesky', 'ETH', 'https://ethereum-holesky-rpc.publicnode.com', 'https://holesky.etherscan.io', 'https://holesky.etherscan.io/api');
// export const bobSepolia = createChain(
//   ChainId.BobSepolia,
//   'Bob Sepolia',
//   'tETH',
//   'https://bob-rpc.test.sovryn.app',
//   'https://bob-sepolia.explorer.gobob.xyz/',
//   'https://bob-sepolia.explorer.gobob.xyz/api',
// );
export const baseSepolia = createChain(ChainId.BaseSepolia, 'Base Sepolia', 'ETH', 'https://sepolia.base.org', 'https://sepolia.basescan.org', 'https://sepolia.basescan.org/api');
export const modeSepolia = createChain(ChainId.ModeSepolia, 'Mode Sepolia', 'ETH', 'https://sepolia.mode.network', 'https://sepolia.explorer.mode.network/', 'https://sepolia.explorer.mode.network/api');
export const arbitrumSepolia = createChain(ChainId.ArbitrumSepolia, 'Arbitrum Sepolia', 'ETH', 'https://arbitrum-sepolia.drpc.org', 'https://sepolia.arbiscan.io/', 'https://api-sepolia.arbiscan.io/api');
export const core = createChain(ChainId.CoreTestnet2, 'Core Testnet 2', 'tCORE2', 'https://rpc.test2.btcs.network', 'https://scan.test2.btcs.network', 'https://scan.test2.btcs.network/api');
export const supportedChains = [
    merlin,
    ethereumHolesky,
    sepolia,
    // bobSepolia,
    baseSepolia,
    modeSepolia,
    arbitrumSepolia,
    core,
];
export const AIRDROP_API_MAP = {
    [ChainId.MerlinTestnet]: 'https://merlin.airdroper.bitcoinos.build',
    [ChainId.EthereumHolesky]: 'https://holesky.airdroper.bitcoinos.build',
    [ChainId.Sepolia]: 'https://sepolia.airdroper.bitcoinos.build',
    // [ChainId.BobSepolia]: 'https://bobsepolia.airdroper.bitcoinos.build',
    [ChainId.BaseSepolia]: 'https://basesepolia.airdroper.bitcoinos.build',
    [ChainId.ModeSepolia]: 'https://modesepolia.airdroper.bitcoinos.build',
    [ChainId.ArbitrumSepolia]: 'https://arbitrumsepolia.airdroper.bitcoinos.build',
    [ChainId.CoreTestnet2]: 'https://coretestnet2.airdroper.bitcoinos.build',
};
//TODO: in case we need to add more test chains, we can use the following airdrop urls:
// amoy               https://amoy.airdroper.bitcoinos.build/
// bitlayerTestnet    https://bitlayertestnet.airdroper.bitcoinos.build/
// coreTestnet2       https://coretestnet2.airdroper.bitcoinos.build/
// avalancheFuji      https://avalanchefuji.airdroper.bitcoinos.build/
// bscTestnet         https://bsctestnet.airdroper.bitcoinos.build/
// ArbitrumSepolia    https://arbitrumsepolia.airdroper.bitcoinos.build/'
